var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineVideoPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.52 7.86a.749.749 0 1 1 0-1.5h18.96a.749.749 0 1 1 0 1.5H2.52z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77 6.97V2.11c0-.41.34-.75.75-.75s.75.34.75.75v4.86c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM14.73 6.52V2.11c0-.41.34-.75.75-.75s.75.34.75.75v4.41c0 .42-.33.75-.75.75-.41 0-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.08 17.86C9.4 17.46 9 16.66 9 15.65v-2.4c0-1.01.4-1.82 1.09-2.22.69-.4 1.59-.34 2.46.17l2.08 1.2c.87.5 1.38 1.25 1.38 2.05 0 .8-.51 1.55-1.39 2.05l-2.08 1.2c-.48.28-.98.42-1.45.42-.36 0-.7-.09-1.01-.26zm.76-5.53c-.21.12-.34.46-.34.92v2.4c0 .45.13.79.34.92.21.12.57.06.96-.17l2.08-1.2c.39-.23.63-.51.63-.75s-.23-.52-.63-.75l-2.08-1.2c-.26-.15-.51-.23-.7-.23-.1 0-.19.02-.26.06z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineVideoPlay);
export default __webpack_public_path__ + "static/media/vuesax-outline-video-play.3b92560ced1d4c64c241a901d4cc91ab.svg";
export { ForwardRef as ReactComponent };